module.exports = __webpack_public_path__ + "media/images/icons/material/data-0f29606d086dbbfceff0acd231eda4e3.svg";